export default {
  one_time: "Pago único",
  title: "Elija el plan adecuado para usted",
  subtitle:
    "Todos los nuevos usuarios comienzan con una prueba de {0} días — descubra las funciones Pro.",
  free: "Gratis",
  basic: "Básico",
  pro: "Pro",
  month: "por mes",
  year: "por año",
  freeSubtitle: "Ideal para usuarios individuales y pruebas",
  basicSubtitle: "Perfecto para pequeñas y medianas empresas",
  proSubtitle: "Perfecto para grandes empresas y equipos profesionales",
  current: "Plan actual",
  current_plan: "Plan actual",
  try: "Probar gratis",
  upgrade: "Actualizar ahora",
  contact: "Contáctenos",
  contact_sales: "Contactar ventas",
  calcs: "cálculos",
  reports: "informes",
  calls_per_month: "llamadas/mes",
  keys: "claves",
  calculations: "Cálculos de emisiones de carbono",
  f_reports: "Informes PDF",
  f_factor: "Factores de emisión básicos",
  f_no_api: "Sin acceso API",
  f_support: "Soporte por correo/ticket",
  priority_support: "Soporte técnico prioritario",
  b_reports: "Informes Excel",
  b_factor: "Factores de emisión personalizados",
  b_custom_logo: "Logotipo personalizado",
  b_api_access: "Acceso API",
  p_dedicated_support: "Soporte dedicado al cliente",
  p_custom_solutions: "Soluciones personalizadas",
  p_training: "Servicios de capacitación para equipos",
  refund: "Si no está satisfecho durante el período de prueba, puede",
  refund_btn: "solicitar un reembolso",
  refund_suffix: ".",
  powered_by: "Los servicios de pago son proporcionados por",
  pay_provider: "paddle",
  paymentLegal: {
    title: "Avisos legales de pago",
    price_currency:
      "Precio: Los precios se muestran en EUR y se procesan de forma segura a través de Paddle, nuestro comerciante autorizado. Pueden aplicarse impuestos adicionales según su ubicación.",
    vat_tax:
      "IVA: Los clientes comerciales son responsables de cualquier declaración fiscal aplicable. Actualmente no cobramos IVA directamente, pero Paddle maneja los cálculos fiscales en el momento del pago cuando es necesario.",
    payment_method:
      "Los pagos se procesan de forma segura a través de Paddle, admitiendo las principales tarjetas de crédito, PayPal, Apple Pay y métodos de pago específicos de países. No se proporciona servicio de custodia.",
    financial_liability:
      "No proporcionamos servicios de inversión, trading o asesoramiento financiero. El acceso se limita estrictamente a la suscripción SaaS.",
    refund_policy: "Política de reembolso:",
    refund_guarantee:
      "Ofrecemos una garantía de reembolso de 14 días para todas las primeras compras de suscripción realizadas a través de Paddle.",
    refund_request:
      "Las solicitudes de reembolso se pueden enviar a través de la sección Facturación - Pedidos o contactando a nuestro equipo de soporte en cualquier momento.",
    right_of_withdrawal:
      "Al acceder o utilizar funciones pagadas — incluyendo cálculos de emisiones CBAM, generación de informes, uso de API o cálculos automatizados de auditoría — reconoce y acepta que su derecho de desistimiento se considere renunciado según las regulaciones de protección al consumidor de la UE para servicios digitales completamente entregados al uso.",
    subscription_renewals:
      "Las solicitudes de reembolso presentadas dentro de los 7 días posteriores a la renovación son elegibles para un reembolso. Las solicitudes presentadas después de 7 días pueden calificar para un reembolso prorrateado basado en la parte no utilizada del período de facturación. No se otorgan reembolsos para renovaciones cuando ya se han utilizado funciones pagadas durante el ciclo de facturación actual.",
    buy_what_you_need:
      "Los créditos no utilizados se pueden reembolsar en cualquier momento en su totalidad. Los créditos utilizados no son reembolsables.",
    refund_restrictions:
      "No se pueden otorgar reembolsos si: Se ha generado un informe CBAM. Se han realizado cálculos de emisiones o cálculos relevantes para auditoría. Se ha utilizado cualquier punto final de API pagado durante el período de facturación. Se sospecha fraude, mal uso o abuso del servicio.",
    after_refund_approval:
      "Después de la aprobación del reembolso: El acceso a todas las funciones pagadas se revocará inmediatamente. Su cuenta se degradará al plan gratuito. Todas las renovaciones futuras se cancelarán. La cuota restante del plan gratuito se restaurará basada en la parte no utilizada de la asignación gratuita original, y no se restablecerá a la capacidad total.",
  },
  vat_note:
    "Los precios no incluyen IVA aplicable. Los usuarios de la UE están sujetos al IVA local.",
  pay_per_use_desc: "Pago por uso, no se requiere suscripción",
  pay_per_use_benefits_title: "Beneficios del pago por uso",
  pay_per_use_benefit1: "No se requiere suscripción",
  pay_per_use_benefit2: "Solo pague por lo que use",
  pay_per_use_benefit3: "Vitalicio",
  buy_credits: "Comprar créditos",
  most_popular: "Más popular",
  save_with_annual: "Ahorre {amount} con el plan anual",
  monthly: "Mensual",
  annually: "Anual",
  enterprise: "Empresa",
  enterpriseSubtitle: "Soluciones personalizadas diseñadas para usuarios profesionales",
  e_custom_solutions: "Soluciones personalizadas",
  start_trial: "Prueba de {0} días disponible al registrarse",
  all_paid_plans_include_free: "Todos los planes pagados incluyen todo lo del plan gratuito.",
  fq: {
    title: "Preguntas frecuentes sobre facturación y suscripción",
    plans_q: "¿Qué planes de suscripción están disponibles?",
    plans_a:
      "Ofrecemos Gratis (100 cálculos/mes), Prueba de 14 días (500 cálculos), Básico (49 €/mes), Pro (99 €/mes) y Pago por uso (1,5 €/cálculo). Compare detalles en la página de precios.",
    upgrade_q: "¿Puedo actualizar o degradar mi plan?",
    upgrade_a:
      "Sí, actualice o degrade instantáneamente en la configuración de la cuenta. Los cambios surten efecto inmediatamente con ajustes prorrateados.",
    trial_q: "¿Cómo funciona la prueba gratuita?",
    trial_a:
      "Los nuevos usuarios obtienen una prueba de {0} días con todas las funciones Pro. Vuelve al plan gratuito ({1} cálculos) a menos que se actualice.",
    autocharge_q: "¿Mi suscripción se renovará automáticamente?",
    autocharge_a:
      "Sí, la renovación automática está habilitada por defecto. Desactívela en cualquier momento en la configuración de facturación.",
    payment_methods_q: "¿Qué métodos de pago se admiten?",
    payment_methods_a:
      "Los pagos se procesan de forma segura a través de nuestro proveedor de pagos oficial Paddle, admitiendo las principales tarjetas de crédito, PayPal, Apple Pay y métodos de pago regionales. El IVA y los impuestos aplicables se calculan automáticamente en el momento del pago por Paddle.",
    invoice_q: "¿Proporcionan facturas con IVA?",
    invoice_a:
      "Sí, las facturas conformes al IVA están disponibles después del pago. Los clientes de la UE deben tener un número de IVA válido para beneficiarse de la exención fiscal.",
    refund_q: "¿Puedo solicitar un reembolso?",
    refund_a:
      "Las solicitudes de reembolso se pueden enviar a través de la página de Suscripción en la Configuración de la cuenta. La elegibilidad para reembolso sigue nuestra política de reembolso de 14 días.",
    data_security_q: "¿Cómo se protegen mis datos?",
    data_security_a:
      "Cumplimos con el RGPD, usando transmisión cifrada y almacenamiento seguro. Los datos son privados para su cuenta.",
    cancel_q: "¿Qué pasa si cancelo?",
    cancel_a:
      "Cancele en cualquier momento en la configuración de suscripción. El acceso dura hasta el final del ciclo de facturación, luego vuelve al plan gratuito.",
  },
};
